export type TypeRouterMode = 'browser' | 'hash';

const routerMode: TypeRouterMode = process.env.REACT_APP_ROUTER_MODE === 'hash' ? 'hash' : 'browser';

const apiUrl = (process.env.REACT_APP_API_URL ?? '').replace(/\/+$/, '');
const placesKey = process.env.REACT_APP_GOOGLE_PLACES_KEY ?? '';

if (!apiUrl && process.env.NODE_ENV !== 'test') {
    console.error('[beDashboard] REACT_APP_API_URL non impostata: nessuna chiamata al backend potrà partire.');
}

if (!placesKey && process.env.NODE_ENV !== 'test') {
    console.warn('[beDashboard] REACT_APP_GOOGLE_PLACES_KEY non impostata: l’autocomplete delle vie è spento e gli indirizzi dei clienti non si verificano.');
}

export const ENV = {
    routerMode,
    apiUrl,
    placesKey,
} as const;
